// GAVION: invite and recovery links come back from Supabase Auth as
// <redirect>#access_token=…&refresh_token=…&type=invite. The app uses a hash
// router, so that fragment is not a route. public/auth-callback.html rewrites it,
// but any landing page can receive it (a cached service worker serving
// index.html, a phone browser, an old link pointing at /set-password). The app
// entry therefore rewrites it too, before the router starts.

const CALLBACK_TYPES = new Set(["invite", "recovery", "magiclink", "signup"]);

/** The URL to replace the current one with, or null when the hash is not a token callback. */
export function authHashRedirect(location: {
  origin: string;
  hash: string;
}): string | null {
  if (!location.hash.startsWith("#") || location.hash.startsWith("#/")) {
    return null;
  }
  const params = new URLSearchParams(location.hash.substring(1));
  const accessToken = params.get("access_token");
  const refreshToken = params.get("refresh_token");
  const type = params.get("type");
  if (!accessToken || !refreshToken || !type || !CALLBACK_TYPES.has(type)) {
    return null;
  }
  const query = new URLSearchParams({
    access_token: accessToken,
    refresh_token: refreshToken,
    type,
  });
  return `${location.origin}/#/auth-callback?${query.toString()}`;
}
